import { createSlice } from '@reduxjs/toolkit';
import { sendEmailDistributionApi } from '../../../rtk-apis/distribution/sendEmailDistribution';

const initialState = {
  status: '',
  result: null as any,
  msg: '',
  loading: false,
};

const sendEmailDistributionSlice = createSlice({
  name: 'sendEmailDistribution',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.result = null;
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(sendEmailDistributionApi.pending, state => {
        state.loading = true;
      })
      .addCase(sendEmailDistributionApi.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.result = action.payload;
        state.msg = action.payload?.msg || 'Report emailed';
      })
      .addCase(sendEmailDistributionApi.rejected, (state, action) => {
        state.loading = false;
        state.status = 'FAILED';
        // The server's reason is kept verbatim — "address rejected by the mail
        // provider" and "the PDF could not be generated" need different actions from
        // the sender, and a generic "send failed" hides which one happened.
        state.msg = (action.payload as string) || 'Email send failed';
      });
  },
});

export const { clearState: clearSendEmailDistributionState } =
  sendEmailDistributionSlice.actions;
export default sendEmailDistributionSlice.reducer;
